/* Model dependencies */
import { userModel } from '@/domain/login/user.model';

import { apiListScreen } from '@/infrastructure/apis/attentionQueues';
import { screenListExecute } from '@/application/monitor/screenList.user-case';

const namespaced = true;

const state = () => ({
  user: userModel,
  citicketstas: [],
  tickets: [],
  screenList: [],
});

const getters = {
  tickets: (state) => state.tickets,
  screenList: (state) => state.screenList,
};

const mutations = {
  SET_TICKETS(state, value) {
    state.tickets = value;
  },
  SET_SCREEN_LIST(state, value) {
    state.screenList = value;
  },
};

const actions = {
  async screenList({ commit }, payload) {
    const responseScreenList = await screenListExecute(payload, apiListScreen);
    commit('SET_SCREEN_LIST', responseScreenList);
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
